import React, { useState } from 'react';
import { Container, Row, Col, Panel, Message, toaster } from 'rsuite';
import EmailVerification from '../components/EmailVerification';
import PageBase from '../components/PageBase';
import Header from '../layouts/Header';
import { actionCreators } from '../state';
import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { authUserData } from '../service';

export default function EmailVerificationPage() {
  const [verificationResult, setVerificationResult] = useState<string>('');
  const [isVerified, setIsVerified] = useState<boolean>(false);
  const user = authUserData();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { updateUser } = bindActionCreators(actionCreators, dispatch);

  const handleVerificationSuccess = async (email: string) => {
    setVerificationResult(`Email ${email} 驗證成功!`);
    setIsVerified(true);

    if (user) {
      console.log("Updated user email:", user);
      updateUser({ ...user, email });
    }

    toaster.push(
      <Message type="success">
        🎉 驗證成功! 您現在可以繼續。
      </Message>,
      { placement: 'topCenter', duration: 5000 }
    );
  };

  const handleVerificationError = (error: string) => {
    setVerificationResult(`驗證失敗: ${error}`);
    setIsVerified(false);
  };

  const resetVerification = () => {
    setVerificationResult('');
    setIsVerified(false);
  };

  const header = (
    <Header
      HeaderTitle="會員資料修改"
      isShowRefresh={false}
      OnReturn={() => navigate('/rider')}
      OnRefresh={resetVerification}
    />
  );

  const content = (
    <Container style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <Row>
        <Col xs={24}>
          <Panel
            header={<h5>Email 修改</h5>}
            bordered
            style={{ marginBottom: '20px' }}
          >
            <div style={{ padding: '20px 0' }}>
              {/* <p style={{ color: '#666', marginBottom: '20px' }}>
                This demo showcases the Email Verification component integration with the EasyRide API.
                Enter your email address to receive a verification code and test the complete flow.
              </p> */}

              {!isVerified ? (
                <EmailVerification
                  onVerificationSuccess={handleVerificationSuccess}
                  onVerificationError={handleVerificationError}
                  title="驗證您的電子郵件地址"
                  subtitle="我們將向您的電子郵件地址發送 6 位數的代碼"
                />
              ) : (
                <div style={{ textAlign: 'center', padding: '40px 0' }}>
                  <div style={{
                    fontSize: '48px',
                    color: '#4CAF50',
                    marginBottom: '20px'
                  }}>
                    ✅
                  </div>
                  <h4 style={{ color: '#4CAF50', marginBottom: '10px' }}>
                    Email 驗證成功!
                  </h4>
                  <p style={{ color: '#666', marginBottom: '20px' }}>
                    {verificationResult}
                  </p>
                  <button
                    onClick={resetVerification}
                    style={{
                      padding: '10px 20px',
                      backgroundColor: '#1976d2',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '14px'
                    }}
                  >
                    重新嘗試使用不同的電子郵件
                  </button>
                </div>
              )}
            </div>
          </Panel>


        </Col>
      </Row>
    </Container>
  );

  return <PageBase header={header} content={content} showSide={false} />;
}